const tripDayStamp = (value) => {
  const day = String(value || '').slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(day) ? day : '';
};

export const tripDateTimeBounds = (trip) => {
  const startDay = tripDayStamp(trip?.start_date);
  const endDay = tripDayStamp(trip?.end_date) || startDay;
  if (!startDay) return null;
  return { min: `${startDay}T00:00`, max: `${endDay}T23:59` };
};

export const localDateTimeValue = (date) => {
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const clampToTrip = (value, bounds) => {
  if (!value) return '';
  const normalized = String(value).replace(' ', 'T').slice(0, 16);
  if (!bounds) return normalized;
  if (normalized < bounds.min) return bounds.min;
  if (normalized > bounds.max) return bounds.max;
  return normalized;
};

export const defaultTimesInTrip = (bounds) => {
  if (!bounds) {
    const start = new Date(Date.now() + 60 * 60 * 1000);
    const end = new Date(start.getTime() + 60 * 60 * 1000);
    return { start: localDateTimeValue(start), end: localDateTimeValue(end) };
  }
  const day = bounds.min.slice(0, 10);
  return { start: `${day}T09:00`, end: `${day}T10:00` };
};

export const isWithinTrip = (value, bounds) => {
  if (!bounds || !value) return true;
  const normalized = String(value).replace(' ', 'T').slice(0, 16);
  return normalized >= bounds.min && normalized <= bounds.max;
};
